'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { Input } from '@material-bank/mb3-components';
import { CountrySelector, usePhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
type PhoneInputProps = {
  value: string;
  onChange: (phone: string) => void;
  id?: string;
  placeholder?: string;
};
export function PhoneInput(t0) {
  const $ = _c(20);
  const {
    value,
    onChange,
    id,
    placeholder: t1
  } = t0;
  const placeholder = t1 === undefined ? "00 000 0000" : t1;
  const inputRef = useRef(null);
  let t2;
  if ($[0] !== onChange) {
    t2 = data => onChange(data.phone);
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2 || $[3] !== value) {
    t3 = {
      defaultCountry: "us",
      value,
      disableDialCodeAndPrefix: true,
      onChange: t2,
      inputRef
    };
    $[2] = t2;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    inputValue,
    handlePhoneValueChange,
    country,
    setCountry
  } = usePhoneInput(t3);
  let t4;
  if ($[5] !== setCountry) {
    t4 = countryData => setCountry(countryData.iso2);
    $[5] = setCountry;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: "24px",
      height: "24px",
      clipPath: "circle(36%)"
    };
    t6 = {
      className: "!z-50"
    };
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== country.iso2 || $[10] !== t4) {
    t7 = <CountrySelector selectedCountry={country.iso2} onSelect={t4} buttonClassName="!border-none !bg-transparent !p-0 !h-auto" flagStyle={t5} dropdownStyleProps={t6} />;
    $[9] = country.iso2;
    $[10] = t4;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handlePhoneValueChange || $[13] !== id || $[14] !== inputValue || $[15] !== placeholder) {
    t8 = <Input id={id} type="tel" ref={inputRef} value={inputValue} placeholder={placeholder} onChange={handlePhoneValueChange} variant="ghost" className="!ring-0 !ring-offset-0" />;
    $[12] = handlePhoneValueChange;
    $[13] = id;
    $[14] = inputValue;
    $[15] = placeholder;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="flex items-center gap-1 rounded-[10px] border border-input bg-background-input px-3 focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}